import { render, staticRenderFns } from "./sp-feature-quote-description.vue?vue&type=template&id=7347f344&scoped=true"
import script from "./sp-feature-quote-description.vue?vue&type=script&lang=js"
export * from "./sp-feature-quote-description.vue?vue&type=script&lang=js"
import style0 from "./sp-feature-quote-description.vue?vue&type=style&index=0&id=7347f344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347f344",
  null
  
)

export default component.exports